var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-select" },
    [
      _c(
        "validation-message",
        {
          attrs: {
            valid: _vm.valid,
            invalid: _vm.invalid,
            validationMessage: _vm.validationMessage
          }
        },
        [
          _c("div", { staticClass: "c-select__group" }, [
            _c("div", { staticClass: "c-select__container" }, [
              _c(
                "label",
                { staticClass: "c-select__label", attrs: { for: _vm.id } },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "c-select__icon",
                      attrs: { "aria-hidden": "true", focusable: "false" }
                    },
                    [
                      _c("use", {
                        attrs: {
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                          "xlink:href": "#chevron-down"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.internalValue,
                          expression: "internalValue"
                        }
                      ],
                      staticClass: "c-select__field",
                      class: { "is-active": _vm.hasValue },
                      attrs: {
                        id: _vm.id,
                        name: _vm.id,
                        required: _vm.required,
                        disabled: _vm.disabled
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.internalValue = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          _vm.valueUpdated
                        ]
                      }
                    },
                    [
                      _vm.placeholder
                        ? _c(
                            "option",
                            {
                              attrs: { disabled: "", selected: "", hidden: "" }
                            },
                            [_vm._v(_vm._s(_vm.placeholder))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.options, function(option) {
                        return _c(
                          "option",
                          {
                            key: option.value,
                            domProps: { value: option.value }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t" +
                                _vm._s(option.label) +
                                "\n\t\t\t\t\t\t\t"
                            )
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "visually-hidden" }, [
                    _vm._v(_vm._s(_vm.label))
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "c-select__label-text",
                      attrs: { "aria-hidden": "true" }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.placeholder ? _vm.placeholder : _vm.label) +
                          "  "
                      ),
                      _vm.required
                        ? _c("span", { staticClass: "c-select__required" }, [
                            _vm._v(" *")
                          ])
                        : _vm._e()
                    ]
                  )
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _vm.tooltip
        ? _c("div", { staticClass: "c-tooltip" }, [_c("ToolTip")], 1)
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-627adf5c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-627adf5c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/reportAProblem/forms/select/SelectDropdown.vue
// module id = 669
// module chunks = 0